<template>
    <div class="root">
        <div class="title">诺伊人名生成器</div>
        <div class="search-root">
            <i-form class="form" :label-width="50">
                <i-form-item label="姓">
                    <i-input v-model="firstName" placeholder="您可以指定生成名字的姓"></i-input>
                </i-form-item>
                <i-form-item label="名">
                    <i-input  v-model="lastName" placeholder="您可以指定生成名字的名"></i-input>
                </i-form-item>
                <i-form-item label="性别">
                    <i-radio-group v-model="nameType">
                        <i-radio label="0">男</i-radio>
                        <i-radio label="1">女</i-radio>
                    </i-radio-group>
                </i-form-item>
                <i-form-item label="长度">
                    <i-radio-group  v-model="nameLength">
                        <i-radio label="1">单字名</i-radio>
                        <i-radio label="2">双字名</i-radio>
                    </i-radio-group>
                </i-form-item>
            </i-form>
            <div style="margin-left: 16px;margin-right: 16px">
                <i-button :loading="isLoading" type="primary" long @click="generateNames">生成</i-button>
            </div>
            <div class="names-panel">
                <div class="name-item" v-clipboard="item" @success="copySuccess" @error="copyFailed" v-for="(item,index) in names" :style="{background:generatedType==='0'?'#e9e7ff':'#fff6fc'}">
                    {{item}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import IInput from "view-design/src/components/input/input";
    import IButton from "view-design/src/components/button/button";
    import IForm from "view-design/src/components/form/form";
    import IFormItem from "view-design/src/components/form-item";
    import IRadioGroup from "view-design/src/components/radio-group";
    import IRadio from "view-design/src/components/radio/radio";
    import VueClipboards from 'vue-clipboards';
    import {generateNames} from "@/net/service/nameService";

    export default {
        components: {IForm, IInput, IButton, IFormItem, IRadioGroup, IRadio},
        name: "name-generator",
        data() {
            return {
                nameType: "0",
                firstName: "",
                lastName: "",
                nameLength: "1",
                isLoading: false,
                generatedType:0,
                names: []
            }
        },
        methods: {
            generateNames() {
                this.isLoading = true;
                let that = this;

                generateNames({
                    nameType: that.nameType,
                    count: 20,
                    nameLength: that.nameLength,
                    firstName: that.firstName,
                    lastName: that.lastName
                }).then(res => {
                    that.names = res.data.data;
                    that.generatedType = that.nameType;
                    document.body.scrollTop = document.body.offsetHeight;
                    document.documentElement.scrollTop = document.body.offsetHeight;
                }).catch(err => {
                    that.$Loading.error();
                }).finally(function () {
                    that.isLoading = false
                });
            },
            copySuccess() {
                this.$Message.success("复制成功！")
            },
            copyFailed() {
                this.$Message.error("复制失败！")
            }
        }
    }
</script>

<style scoped>
    .title {
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        padding-top: 16px;
    }

    .root {
        display: flex;
        flex-direction: column;
    }

    .form {
        border: 1px solid #EFEFEF;
        margin: 16px;
        padding: 16px;
        border-radius: 8px;
    }
    .name-item {
        border-radius: 4px;
        width: auto;
        margin: 4px;
        padding: 8px;
        text-align: center;
        color: #000000;
        cursor: pointer;
    }
    .names-panel {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        margin: 16px;
        border-radius: 8px;
        border: 1px solid #EFEFEF;
        padding: 8px;
    }
</style>